import '../styles/App.css';

import logo from '../assets/logo.svg';
import Navbar from './Navbar.js';
import Home from '../pages/Home.js';
import Blacklist from '../pages/Blacklist.js';
import Whitelist from '../pages/Whitelist.js';
import Calls from '../pages/Calls.js';
import Settings from '../pages/Settings.js';
import Contacts from '../pages/Contacts.js';

import { BrowserRouter, Switch, Route } from 'react-router-dom';

function App() {
  return (
    <div className="App">
        <div className="row">
            <div className="side-column"></div>
            <div className="main-column">
                <BrowserRouter>
                    <Navbar class='first'/>
                    <Switch>
                        <Route path='/' exact component={Home}/>
                        <Route path='/liste-noire' component={Blacklist}/>
                        <Route path='/liste-blanche' component={Whitelist}/>
                        <Route path='/journal-appels' component={Calls}/>
                        <Route path='/reglages' component={Settings}/>
                        <Route path='/contacts' component={Contacts}/>
                    </Switch>
                </BrowserRouter>
                <div className="logo-container">
                    <a href="/">
                        <img src={logo} className="App-logo" alt="logo"/>
                    </a>
                </div>
            </div>
            <div className="side-column"></div>
        </div>
    </div>
  );
}

export default App;
